<template>
  <div class="main">
    <div v-if="showType">
      <div
        @click="go"
        :class="[giftInfo.days === 30 ? 'showbox30' : 'showbox']"
      >
        <!--      <div class="content" :style="{ marginLeft: msgStyleLeft + 'px' }">-->
        <!--        {{ showMessage }}-->
        <!--      </div>-->
      </div>
      <div class="close" @click="close">
        <img src="../../assets/image/prompt/closeGift.png" />
      </div>
    </div>
    <div v-else>
      <div class="success">
        <div class="content">
          <p>成功领取{{ giftInfo.days === 30 ? "30" : 7 }}天内容神器试用</p>
          <p>到期时间：{{ giftTime.replace(" 00:00", "") }}</p>
        </div>
        <div class="infobtn">
          <button class="usebtn" @click="use">马上使用</button>
          <button class="qxbtn" @click="jump">权限介绍</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../assets/script/config/index.js";
import { mapActions, mapMutations, mapState } from "vuex";
// import Cookies from "js-cookie";
export default {
  name: "showGift",
  data() {
    return {
      vipUrl: config.vipUrl
    };
  },
  props: {
    showType: {
      type: Boolean,
      default: true
    }
  },
  mounted() {},
  computed: {
    ...mapState("user", ["userToken", "giftInfo"]),
    ...mapState("contents", ["useGift", "giftTime"])
  },
  methods: {
    ...mapActions("user", ["getRegisterGive"]),
    ...mapMutations("contents", [
      "setShowLoginDialogs",
      "setUseGift",
      "setGiftTime"
    ]),
    close() {
      this.$emit("closeShowGift", false);
    },
    async go() {
      //DO work
      if (this.userToken) {
        let setData = 0;
        let source = "";
        let data = { givesource: source, days: setData };
        if (Object.keys(this.giftInfo).length > 0) {
          data = this.giftInfo;
        }
        console.log(data);
        let result = await this.getRegisterGive(data);
        if (result.success) {
          this.setGiftTime(result.data.endTime);
          this.insertConfig.setGiftCookies(2);
          this.setUseGift(false);
        } else {
          this.$message({
            showClose: true,
            message: result.errorMsg,
            type: "error"
          });
        }
        this.$emit("closeShowGift", false);
      } else {
        this.$emit("closeShowGift", false);
        this.insertConfig.setGiftCookies(1);
        this.setShowLoginDialogs(true);
      }
    },
    use() {
      window.location.reload();
    },
    jump() {
      this.$emit("closeShowGift", false);
      window.open(this.vipUrl + "/price");
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background-color: rgba(63, 61, 61, 0.5);
  transition: opacity 0.3s;
  z-index: 10000;
  .showbox {
    cursor: pointer;
    width: 440px;
    height: 400px;
    background: url("../../assets/image/prompt/showGift.png");
    position: absolute;
    top: 45%;
    left: 50%;
    margin-left: -220px;
    margin-top: -188px;
    .content {
      margin-top: 210px;
      margin-left: 70px;
      color: #986a17;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
    }
  }
  .showbox30 {
    cursor: pointer;
    width: 440px;
    height: 400px;
    background: url("../../assets/image/prompt/showGift30.png");
    position: absolute;
    top: 45%;
    left: 50%;
    margin-left: -220px;
    margin-top: -188px;
    .content {
      margin-top: 210px;
      margin-left: 70px;
      color: #986a17;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
    }
  }
  .close {
    top: 50%;
    left: 50%;
    margin-top: -180px;
    position: fixed;
    margin-left: 185px;
    cursor: pointer;
  }
  .success {
    width: 280px;
    height: 249px;
    background: url("../../assets/image/prompt/successGift.png");
    position: absolute;
    top: 45%;
    left: 50%;
    margin-left: -140px;
    margin-top: -150px;
    .content {
      margin-top: 175px;
      margin-left: 50px;
      text-align: center;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      position: absolute;
      p {
        &:nth-child(2) {
          margin-top: 15px;
          font-size: 12px;
        }
      }
    }
    .infobtn {
      margin-top: 265px;
      margin-left: 23px;
      .tbtn {
        padding: 5px 20px;
        border-radius: 20px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
      }
      .usebtn {
        .tbtn();
        border: 1px solid #e4273d;
        background-color: #e4273d;
      }
      .qxbtn {
        .tbtn();
        margin-left: 20px;
        background-color: #b2b2b2;
        border: 1px solid #fff;
      }
    }
  }
}
</style>
